import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {
    Accordion, AccordionDetails, AccordionSummary, Button,
    CircularProgress, Drawer, Fab, Icon, IconButton, Typography,
} from "@mui/material";
import {Box} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SouffletsAnalyse from "./soufflets/final/SouffletsAnalyse";
import GroupByPersonnae from "./soufflets/GroupByPersonnae";
import Synthese from "./soufflets/Synthese";
import GroupByBvs from "./soufflets/GroupByBvs";
import {
    getDataCity,
    getInfoElection,
    getLabelFromNuance, getLastDateElection,
    getNomElection,
    labelGagnant, mappingChelou,
    percentageRepresentation,
} from "./Utils";
import MapEpci from "./soufflets/final/maps/MapEpci";
import GroupByIris from "./soufflets/GroupByIris";
import ApiVoteCtrl from "./svc/vote/ApiVoteCtrl";
import MapBvs from "./soufflets/final/maps/MapBvs";
import {useStyles} from "./Style";

import PrintIcon from '@mui/icons-material/Print';
import {Margin, Resolution, usePDF} from "react-to-pdf";
import {PDFExport} from "@progress/kendo-react-pdf";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import WestIcon from '@mui/icons-material/West';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Page1 from "./pages/Page1";
import Page2 from "./pages/Page2";
import Page3 from "./pages/Page3";
import SyntheseMain from "./soufflets/SyntheseMain";

export default function AppDatavoteHeader({codeInsee, electionType}) {
    const datesByElection = {
        "muni": {min: 2007, max: 2020},
        "legi": {min: 2017, max: 2024}
    }



    const [loading, setLoading] = React.useState(true);




    function generateEpciMap(result) {
        let resultsOfEpcis = {};

        Object.keys(result.bvResultsEpci).forEach((codeInsee) => {
            const inseeCom = result.bvResultsEpci[codeInsee];
            resultsOfEpcis[codeInsee] = {
                inscrits: 0,
                abstentions: 0,
                winner: null
            }
            let resultsOfCandiats = {};
            Object.keys(inseeCom[0].bvResultsMap).forEach((bvId) => {
                const bv = inseeCom[0].bvResultsMap[bvId];

                let idLastVote = datesByElection[electionType].max + "_" + electionType + "_t2";
                if (!bv.elections[idLastVote]) {
                    idLastVote = datesByElection[electionType].max + "_" + electionType + "_t1";
                }

                const lastResults = bv.elections[idLastVote];
                if (lastResults) {
                    resultsOfEpcis[codeInsee]["inscrits"] += lastResults.ins;
                    resultsOfEpcis[codeInsee]["abstentions"] += lastResults.abs;
                    lastResults.c.forEach((canddiat) => {
                        if (!resultsOfCandiats[canddiat.nomPrenom]) {
                            resultsOfCandiats[canddiat.nomPrenom] = {
                                nomPrenom: canddiat.nomPrenom,
                                inscrit: 0,
                                nb: 0,
                                perc: 0,
                                nuance: canddiat.nuance
                            }
                        }
                        resultsOfCandiats[canddiat.nomPrenom].nb += canddiat.r;
                    })
                }
            })
            let winner = null;
            Object.keys(resultsOfCandiats).forEach((candidat) => {
                if (!winner) {
                    winner = resultsOfCandiats[candidat];
                } else if (resultsOfCandiats[candidat].nb > winner.nb) {
                    winner = resultsOfCandiats[candidat];
                }
            })
            resultsOfEpcis[codeInsee]["winner"] = winner;

        })
        return resultsOfEpcis;
    }

    function aggregateResultsByYear(result) {
        let r = {};
        Object.keys(result.bvResultsComboMongo[0].bvResultsMap).forEach((bvId) => {
            const bv = result.bvResultsComboMongo[0].bvResultsMap[bvId];
            Object.keys(bv.elections).forEach((election) => {
                if (bv.elections[election].type === electionType) {
                    if (!r[bv.elections[election].annee]) {
                        r[bv.elections[election].annee] = {}
                    }
                    if (!r[bv.elections[election].annee][bv.elections[election].tour]) {
                        r[bv.elections[election].annee][bv.elections[election].tour] = [];
                    }
                    let elec = bv.elections[election];
                    elec.bvId = bvId;
                    r[bv.elections[election].annee][bv.elections[election].tour].push(elec);
                }
            })
        })
        return r;
    }

    function generateSyntheseCommune(r) {


        let resultsSynthese = []
        let previousAbstention = null;
        Object.keys(r).sort().forEach((year) => {
            let tour = "t2"
            if (!r[year][tour]) {
                tour = "t1"
            }
            let inscrit = 0
            let abstention = 0
            let exprime = 0
            r[year][tour].forEach(election => {
                inscrit += election.ins
                abstention += election.abs
                exprime += election.exp
            })


            let resultsByCandidats = {};
            r[year][tour].forEach(election => {
                election.c.forEach((canddiat) => {
                    if (!resultsByCandidats[canddiat.nomPrenom]) {
                        resultsByCandidats[canddiat.nomPrenom] = canddiat
                    } else {
                        resultsByCandidats[canddiat.nomPrenom].r += canddiat.r
                    }
                })
            })

            let winner = null;
            let preivousWinner = null;
            Object.keys(resultsByCandidats).forEach((candidat) => {
                if (!winner) {
                    winner = resultsByCandidats[candidat];
                } else if (resultsByCandidats[candidat].r > winner.r) {
                    preivousWinner = winner;
                    winner = resultsByCandidats[candidat];
                } else if (!preivousWinner) {
                    preivousWinner = resultsByCandidats[candidat];
                }
            })
            if (preivousWinner === null) {
                preivousWinner = {
                    r: 0
                }
            }
            let perc = (winner.r / exprime) - (preivousWinner.r / exprime)
            if (Object.keys(resultsByCandidats).length <= 1) {
                perc = 1
            }
            resultsSynthese.push({
                year: year,
                type: getNomElection[electionType],
                inscrit: {
                    nb: inscrit
                },
                abstention: {
                    result: abstention,
                    perc: abstention / inscrit,
                    color: "#000",
                    trendPerc: computerTrendAbs(previousAbstention, abstention / inscrit)
                },
                winner: {
                    nomPrenom: winner.nomPrenom,
                    result: winner.r,
                    perc: winner.r / exprime,
                    color: getInfoElection(perc).color
                },
                nuance: getLabelFromNuance(winner.nuance, year),
                tour: tour,
            })


            previousAbstention = abstention / inscrit
        });

        return resultsSynthese.reverse()
    }

    function generateResultatsCommune(r) {

        let results = {
            inscrits: {},
            inscrits2: {},
            abstentions: {},
            blancs: {},
//            nuls: {},
            tour: "t1"
        }
        let previousYear = null;
        Object.keys(r).sort().reverse().forEach((year) => {
            if (!results.inscrits[year]) {
                results.inscrits[year] = {nb: 0, perc: null, trendPerc: null, trend: null}
                results.inscrits2[year] = {t1: {nb: 0, perc: null, trendPerc: null, trend: null}}
                results.abstentions[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                results.blancs[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                //  results.nuls[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
            }
            r[year]["t1"].forEach(election => {
                results.inscrits[year].nb += election.ins;
                results.inscrits2[year]["t1"].nb += election.ins;

                results.abstentions[year]["t1"].nb += election.abs;
                results.abstentions[year]["t1"].perc = results.abstentions[year]["t1"].nb / results.inscrits2[year]["t1"].nb;

                results.blancs[year]["t1"].nb += election.bla + election.nuls;
                results.blancs[year]["t1"].perc = results.blancs[year]["t1"].nb / results.inscrits2[year]["t1"].nb;

//                results.nuls[year]["t1"].nb += election.nuls;
                //               results.nuls[year]["t1"].perc = results.nuls[year]["t1"].nb / results.inscrits[year].nb;

            })
            if (r[year]["t2"]) {
                if (!results.abstentions[year]["t2"]) {
                    results.inscrits2[year]["t2"] = {nb: 0, perc: null, trendPerc: null, trend: null}
                    results.abstentions[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                    results.blancs[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                    // results.nuls[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                    results["tour"] = "t2"
                }
                r[year]["t2"].forEach(election => {
                    results.inscrits2[year]["t2"].nb += election.ins;
                    results.inscrits2[year]["t2"].trendPerc = results.inscrits2[year]["t1"].nb > 0 ? (results.inscrits2[year]["t2"].nb / results.inscrits2[year]["t1"].nb) - 1 : 0;
                    if (results.inscrits2[year]["t2"].trendPerc >= 0) {
                        results.inscrits2[year]["t2"].trend = "up"
                    } else {
                        results.inscrits2[year]["t2"].trend = "down"
                    }

                    results.abstentions[year]["t2"].nb += election.abs;
                    results.abstentions[year]["t2"].perc = results.abstentions[year]["t2"].nb / results.inscrits2[year]["t2"].nb;
                    results.abstentions[year]["t2"].trendPerc = results.abstentions[year]["t1"].nb > 0 ? (results.abstentions[year]["t2"].nb / results.abstentions[year]["t1"].nb) - 1 : 0;
                    if (results.abstentions[year]["t2"].trendPerc >= 0) {
                        results.abstentions[year]["t2"].trend = "up"
                    } else {
                        results.abstentions[year]["t2"].trend = "down"
                    }

                    results.blancs[year]["t2"].nb += election.bla + election.nuls;
                    results.blancs[year]["t2"].perc = results.blancs[year]["t2"].nb / results.inscrits2[year]["t2"].nb;
                    results.blancs[year]["t2"].trendPerc = results.blancs[year]["t1"].nb > 0 ? (results.blancs[year]["t2"].nb / results.blancs[year]["t1"].nb) - 1 : 0;
                    if (results.blancs[year]["t2"].trendPerc >= 0) {
                        results.blancs[year]["t2"].trend = "up"
                    } else {
                        results.blancs[year]["t2"].trend = "down"
                    }

                    /*                    results.nuls[year]["t2"].nb += election.nuls;
                                        results.nuls[year]["t2"].perc = results.nuls[year]["t2"].nb / results.inscrits[year].nb;
                                        results.nuls[year]["t2"].trendPerc = results.nuls[year]["t1"].nb > 0 ? (results.nuls[year]["t2"].nb / results.nuls[year]["t1"].nb) - 1 : 0;
                                        if (results.nuls[year]["t2"].trendPerc >= 0) {
                                            results.nuls[year]["t2"].trend = "up"
                                        } else {
                                            results.nuls[year]["t2"].trend = "down"
                                        }*/
                })
            }
            previousYear = year;
        })
        return results;
    }

    function generateParCandidatsResultatsNuancesCommune(r) {

        let results = {
            exprime: {},
            candidats: {},
            nuances: {},
            inscrits: {}
        }

        Object.keys(r).sort().reverse().forEach((year) => {
            if (!results.exprime[year]) {
                results.exprime[year] = {t1: 0};
                results.candidats[year] = {t1: {}};
                results.nuances[year] = {t1: {}};
                results.inscrits[year] = 0;
            }
            r[year]["t1"].forEach(bv => {
                results.inscrits[year] += bv.ins;
                results.exprime[year]["t1"] += bv.exp;
                bv.c.forEach(candidat => {
                    if (!results.candidats[year]["t1"][candidat.nomPrenom]) {
                        results.candidats[year]["t1"][candidat.nomPrenom] = {
                            nb: 0,
                            perc: 0,
                            nomPrenom: candidat.nomPrenom,
                            nuance: candidat.nuance
                        }
                    }
                    results.candidats[year]["t1"][candidat.nomPrenom].nb += candidat.r;
                    results.candidats[year]["t1"][candidat.nomPrenom].perc = results.candidats[year]["t1"][candidat.nomPrenom].nb / results.exprime[year]["t1"];

                    if (!results.nuances[year]["t1"][candidat.nuance]) {
                        results.nuances[year]["t1"][candidat.nuance] = {
                            nb: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    results.nuances[year]["t1"][candidat.nuance].nb += candidat.r;
                    results.nuances[year]["t1"][candidat.nuance].perc = results.nuances[year]["t1"][candidat.nuance].nb / results.exprime[year]["t1"];
                })
            })


            if (r[year]["t2"]) {
                if (!results.exprime[year]["t2"]) {
                    results.exprime[year]["t2"] = 0;
                    results.candidats[year]["t2"] = {};
                    results.nuances[year]["t2"] = {};
                }
                r[year]["t2"].forEach(bv => {
                    results.exprime[year]["t2"] += bv.exp;
                    bv.c.forEach(candidat => {

                        if (!results.candidats[year]["t2"][candidat.nomPrenom]) {
                            results.candidats[year]["t2"][candidat.nomPrenom] = {
                                nb: 0,
                                perc: 0,
                                nomPrenom: candidat.nomPrenom,
                                nuance: candidat.nuance
                            }
                        }
                        results.candidats[year]["t2"][candidat.nomPrenom].nb += candidat.r;
                        results.candidats[year]["t2"][candidat.nomPrenom].perc = results.candidats[year]["t2"][candidat.nomPrenom].nb / results.exprime[year]["t2"];

                        if (!results.nuances[year]["t2"][candidat.nuance]) {
                            results.nuances[year]["t2"][candidat.nuance] = {
                                nb: 0,
                                perc: 0,
                                nuance: candidat.nuance
                            }
                        }
                        results.nuances[year]["t2"][candidat.nuance].nb += candidat.r;
                        results.nuances[year]["t2"][candidat.nuance].perc = results.nuances[year]["t2"][candidat.nuance].nb / results.exprime[year]["t2"];
                    })
                })
            }
        })
        return results;
    }

    function filterElement(listOfIris, data, key) {
        let sum = 0;
        listOfIris.forEach(item => {
            sum += Number(data[item][key]);
        });
        return sum
    }

    function generateInseePopResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                if (item2 !== "p22_pop") {
                    sum += Number(csp21[item][item2]);
                }
            })
        });

        let n = csp21;
        const p21_pop0014 = filterElement(listOfIris, n, "p22_pop0014");
        const p21_pop1529 = filterElement(listOfIris, n, "p22_pop1529");
        const p21_pop3044 = filterElement(listOfIris, n, "p22_pop3044");
        const p21_pop4559 = filterElement(listOfIris, n, "p22_pop4559");
        const p21_pop6074 = filterElement(listOfIris, n, "p22_pop6074");
        const p21_pop75p = filterElement(listOfIris, n, "p22_pop75p");

        n = csp15;
        const p15_pop0014 = filterElement(listOfIris, n, "p16_pop0014");
        const p15_pop1529 = filterElement(listOfIris, n, "p16_pop1529");
        const p15_pop3044 = filterElement(listOfIris, n, "p16_pop3044");
        const p15_pop4559 = filterElement(listOfIris, n, "p16_pop4559");
        const p15_pop6074 = filterElement(listOfIris, n, "p16_pop6074");
        const p15_pop75p = filterElement(listOfIris, n, "p16_pop75p");


        let r = [
            {
                name: "Pop 0-14 ans",
                nb: p21_pop0014,
                perc: p21_pop0014 / sum,
                trendPerc: (p21_pop0014 / p15_pop0014) - 1
            },
            {
                name: "Pop 15-29 ans",
                nb: p21_pop1529,
                perc: p21_pop1529 / sum,
                trendPerc: (p21_pop1529 / p15_pop1529) - 1
            },
            {
                name: "Pop 30-44 ans",
                nb: p21_pop3044,
                perc: p21_pop3044 / sum,
                trendPerc: (p21_pop3044 / p15_pop3044) - 1
            },
            {
                name: "Pop 45-59 ans",
                nb: p21_pop4559,
                perc: p21_pop4559 / sum,
                trendPerc: (p21_pop4559 / p15_pop4559) - 1
            },
            {
                name: "Pop 60-74 ans",
                nb: p21_pop6074,
                perc: p21_pop6074 / sum,
                trendPerc: (p21_pop6074 / p15_pop6074) - 1
            },
            {
                name: "Pop 75 ans et plus",
                nb: p21_pop75p,
                perc: p21_pop75p / sum,
                trendPerc: (p21_pop75p / p15_pop75p) - 1
            }
        ]
        console.log(r);
        return r;
    }

    function generateInseeEtuResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                sum += Number(csp21[item][item2]);
            })
        });

        let n = csp21;
        const p21_nscol15p_bac = filterElement(listOfIris, n, "p21_nscol15p_bac");
        const p21_nscol15p_capbep = filterElement(listOfIris, n, "p21_nscol15p_capbep");
        const p21_nscol15p_diplmin = filterElement(listOfIris, n, "p21_nscol15p_diplmin");
        const p21_autre = filterElement(listOfIris, n, "p21_nscol15p_sup2") + filterElement(listOfIris, n, "p21_nscol15p_sup5") + filterElement(listOfIris, n, "p21_nscol15p_sup34");

        n = csp15;
        const p15_nscol15p_bac = filterElement(listOfIris, n, "p15_nscol15p_bac");
        const p15_nscol15p_capbep = filterElement(listOfIris, n, "p15_nscol15p_capbep");
        const p15_nscol15p_diplmin = filterElement(listOfIris, n, "p15_nscol15p_diplmin");
        const p15_autre = filterElement(listOfIris, n, "p15_nscol15p_sup");


        let r = [
            {
                name: "BAC",
                nb: p21_nscol15p_bac,
                perc: p21_nscol15p_bac / sum,
                trendPerc: (p21_nscol15p_bac / p15_nscol15p_bac) - 1
            },
            {
                name: "CAP-BEP",
                nb: p21_nscol15p_capbep,
                perc: p21_nscol15p_capbep / sum,
                trendPerc: (p21_nscol15p_capbep / p15_nscol15p_capbep) - 1
            },
            {
                name: "Sans diplôme",
                nb: p21_nscol15p_diplmin,
                perc: p21_nscol15p_diplmin / sum,
                trendPerc: (p21_nscol15p_diplmin / p15_nscol15p_diplmin) - 1
            },
            {
                name: "Enseignement sup",
                nb: p21_autre,
                perc: p21_autre / sum,
                trendPerc: (p21_autre / p15_autre) - 1
            }
        ]
        return r;
    }

    function generateInseeCspResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                if (item2 !== "c21_pop15p") {
                    sum += Number(csp21[item][item2]);
                }
            })
        });


        let n = csp21;
        const c21_pop15p_cs1 = filterElement(listOfIris, n, "c21_pop15p_cs1");
        const c21_pop15p_cs2 = filterElement(listOfIris, n, "c21_pop15p_cs2");
        const c21_pop15p_cs3 = filterElement(listOfIris, n, "c21_pop15p_cs3");
        const c21_pop15p_cs4 = filterElement(listOfIris, n, "c21_pop15p_cs4");
        const c21_pop15p_cs5 = filterElement(listOfIris, n, "c21_pop15p_cs5");
        const c21_pop15p_cs6 = filterElement(listOfIris, n, "c21_pop15p_cs6");
        const c21_pop15p_cs7 = filterElement(listOfIris, n, "c21_pop15p_cs7");
        const c21_pop15p_cs8 = filterElement(listOfIris, n, "c21_pop15p_cs8");

        n = csp15;
        const c15_pop15p_cs1 = filterElement(listOfIris, n, "c15_pop15p_cs1");
        const c15_pop15p_cs2 = filterElement(listOfIris, n, "c15_pop15p_cs2");
        const c15_pop15p_cs3 = filterElement(listOfIris, n, "c15_pop15p_cs3");
        const c15_pop15p_cs4 = filterElement(listOfIris, n, "c15_pop15p_cs4");
        const c15_pop15p_cs5 = filterElement(listOfIris, n, "c15_pop15p_cs5");
        const c15_pop15p_cs6 = filterElement(listOfIris, n, "c15_pop15p_cs6");
        const c15_pop15p_cs7 = filterElement(listOfIris, n, "c15_pop15p_cs7");
        const c15_pop15p_cs8 = filterElement(listOfIris, n, "c15_pop15p_cs8");


        let r = [
            {
                name: "Agriculteurs exploitants",
                nb: c21_pop15p_cs1,
                perc: c21_pop15p_cs1 / sum,
                trendPerc: (c21_pop15p_cs1 / c15_pop15p_cs1) - 1
            },
            {
                name: "Artisans, Comm., Chefs entr.",
                nb: c21_pop15p_cs2,
                perc: c21_pop15p_cs2 / sum,
                trendPerc: (c21_pop15p_cs2 / c15_pop15p_cs2) - 1
            },
            {
                name: "Cadres, Prof. intel. sup.",
                nb: c21_pop15p_cs3,
                perc: c21_pop15p_cs3 / sum,
                trendPerc: (c21_pop15p_cs3 / c15_pop15p_cs3) - 1
            },
            {
                name: "Prof. intermédiaires",
                nb: c21_pop15p_cs4,
                perc: c21_pop15p_cs4 / sum,
                trendPerc: (c21_pop15p_cs4 / c15_pop15p_cs4) - 1
            },
            {
                name: "Employés",
                nb: c21_pop15p_cs5,
                perc: c21_pop15p_cs5 / sum,
                trendPerc: (c21_pop15p_cs5 / c15_pop15p_cs5) - 1
            },
            {
                name: "Ouvriers",
                nb: c21_pop15p_cs6,
                perc: c21_pop15p_cs6 / sum,
                trendPerc: (c21_pop15p_cs6 / c15_pop15p_cs6) - 1
            },
            {
                name: "Retraités",
                nb: c21_pop15p_cs7,
                perc: c21_pop15p_cs7 / sum,
                trendPerc: (c21_pop15p_cs7 / c15_pop15p_cs7) - 1
            },
            {
                name: "Autres personnes sans activité professionnelle",
                nb: c21_pop15p_cs8,
                perc: c21_pop15p_cs8 / sum,
                trendPerc: (c21_pop15p_cs8 / c15_pop15p_cs8) - 1
            }
        ]
        return r;
    }

    function generateInseeIncomeResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                sum += Number(csp21[item][item2]);
            })
        });


        let n = csp21;
        const p21_actocc1564 = filterElement(listOfIris, n, "p21_actocc1564");
        const p21_chom1564 = filterElement(listOfIris, n, "p21_chom1564");
        const p21_inact1564 = filterElement(listOfIris, n, "p21_inact1564");

        n = csp15;
        const p15_actocc1564 = filterElement(listOfIris, n, "p15_actocc1564");
        const p15_chom1564 = filterElement(listOfIris, n, "p15_chom1564");
        const p15_inact1564 = filterElement(listOfIris, n, "p15_inact1564");

        let r = [
            {
                name: "Actifs occupés",
                nb: p21_actocc1564,
                perc: p21_actocc1564 / sum,
                trendPerc: (p21_actocc1564 / p15_actocc1564) - 1
            },
            {
                name: "Chômeurs",
                nb: p21_chom1564,
                perc: p21_chom1564 / sum,
                trendPerc: (p21_chom1564 / p15_chom1564) - 1
            },
            {
                name: "Inactifs",
                nb: p21_inact1564,
                perc: p21_inact1564 / sum,
                trendPerc: (p21_inact1564 / p15_inact1564) - 1
            }
        ]
        return r;
    }

    function generateInseeLgtResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                if (item2 !== "p21_rp" || item2 !== "p21_rp_lochlmv") {
                    sum += Number(csp21[item][item2]);
                }
            })
        });

        let n = csp21;
        const p21_rp = filterElement(listOfIris, n, "p21_rp");
        const p21_rp_grat = filterElement(listOfIris, n, "p21_rp_grat");
        const p21_rp_lochlmv = filterElement(listOfIris, n, "p21_rp_lochlmv");
        const p21_rp_loc = filterElement(listOfIris, n, "p21_rp_loc") - p21_rp_lochlmv;
        const p21_rp_prop = filterElement(listOfIris, n, "p21_rp_prop");

        n = csp15;
        const p15_rp = filterElement(listOfIris, n, "p15_rp");
        const p15_rp_grat = filterElement(listOfIris, n, "p15_rp_grat");
        const p15_rp_lochlmv = filterElement(listOfIris, n, "p15_rp_lochlmv");
        const p15_rp_loc = filterElement(listOfIris, n, "p15_rp_loc") - p15_rp_lochlmv;
        const p15_rp_prop = filterElement(listOfIris, n, "p15_rp_prop");

        let r = [
            {
                name: "Logé gratuit",
                nb: p21_rp_grat,
                perc: p21_rp_grat / p21_rp,
                trendPerc: (p21_rp_grat / p15_rp_grat) - 1
            },
            {
                name: "Loc. Parc Social",
                nb: p21_rp_lochlmv,
                perc: p21_rp_lochlmv / p21_rp,
                trendPerc: (p21_rp_lochlmv / p15_rp_lochlmv) - 1
            },
            {
                name: "Loc. Parc Privé",
                nb: p21_rp_loc,
                perc: p21_rp_loc / p21_rp,
                trendPerc: (p21_rp_loc / p15_rp_loc) - 1
            },
            {
                name: "Propriétaires",
                nb: p21_rp_prop,
                perc: p21_rp_prop / p21_rp,
                trendPerc: (p21_rp_prop / p15_rp_prop) - 1
            }
        ]
        return r;
    }

    function generateInseeLgtPResults(csp21, csp15, listOfIris) {
        let sum = 0;
        listOfIris.forEach(item => {
            Object.keys(csp21[item]).forEach((item2) => {
                if (item2 !== "p21_men") {
                    sum += Number(csp21[item][item2]);
                }
            })
        });

        let n = csp21;
        const p21_men = filterElement(listOfIris, n, "p21_men");
        const p21_men_anem0002 = filterElement(listOfIris, n, "p21_men_anem0002");
        const p21_men_anem10p = filterElement(listOfIris, n, "p21_men_anem10p");
        const p21_men_anem0204 = filterElement(listOfIris, n, "p21_men_anem0204");
        const p21_men_anem0509 = filterElement(listOfIris, n, "p21_men_anem0509");

        n = csp15;
        const p15_men = filterElement(listOfIris, n, "p15_men");
        const p15_men_anem0002 = filterElement(listOfIris, n, "p15_men_anem0002");
        const p15_men_anem10p = filterElement(listOfIris, n, "p15_men_anem10p");
        const p15_men_anem0204 = filterElement(listOfIris, n, "p15_men_anem0204");
        const p15_men_anem0509 = filterElement(listOfIris, n, "p15_men_anem0509");


        let r = [
            {
                name: "Ménages emménagés moins 2 ans",
                nb: p21_men_anem0002,
                perc: p21_men_anem0002 / p21_men,
                trendPerc: (p21_men_anem0002 / p15_men_anem0002) - 1
            },
            {
                name: "Ménages emménagés depuis 10+ ans",
                nb: p21_men_anem10p,
                perc: p21_men_anem10p / p21_men,
                trendPerc: (p21_men_anem10p / p15_men_anem10p) - 1
            },
            {
                name: "Ménages emménagés entre 2-4 ans",
                nb: p21_men_anem0204,
                perc: p21_men_anem0204 / p21_men,
                trendPerc: (p21_men_anem0204 / p15_men_anem0204) - 1
            },
            {
                name: "Ménages emménagés entre 5-9 ans",
                nb: p21_men_anem0509,
                perc: p21_men_anem0509 / p21_men,
                trendPerc: (p21_men_anem0509 / p15_men_anem0509) - 1
            }
        ]
        return r;
    }

    function generateResultsParDonneesInseeCommune(data) {
        let listOfIris = Object.keys(data.csp21);
        return {
            listOfIris: listOfIris,
            popAge: generateInseePopResults(data.pop21, data.pop15, listOfIris),
            popCsp: generateInseeCspResults(data.csp21, data.csp15, listOfIris),
            popEtu: generateInseeEtuResults(data.edu21, data.edu15, listOfIris),
            popRevenues: generateInseeIncomeResults(data.actif21, data.actif15, listOfIris),
            lgtStatus: generateInseeLgtResults(data.lgt21, data.lgt15, listOfIris),
            lgtPeriode: generateInseeLgtPResults(data.lgtpe21, data.lgtpe15, listOfIris)
        };
    }


    function computerTrendAbs(previousAbstention, number) {
        if (previousAbstention) {

            return (number / previousAbstention) - 1;
        }
        return null;
    }

    function generateBVs(result, winner, currentYear) {
        let listOfBvs = {
            winner: {}, winnerJuste: {}, winnerPeu: {}, winnerLargement: {}
        };
        const tmpBvs = result.bvResultsComboMongo[0].bvResultsMap;
        Object.keys(tmpBvs).forEach((key) => {
            let bvData = {}
            Object.keys(tmpBvs[key].elections).forEach(item => {
                const elec = tmpBvs[key].elections[item];
                if (elec.type === electionType) {
                    if (!bvData[elec.annee]) {
                        bvData[elec.annee] = {}
                    }
                    bvData[elec.annee][elec.tour] = elec
                }
            })
            let res = []
            let previousAbstention = null;
            let lastYearStatus = null;
            Object.keys(bvData).sort().forEach((year) => {
                let tour = "t2";
                if (!bvData[year]["t2"]) {
                    tour = "t1";
                }
                let abstention = bvData[year][tour].abs;
                let inscrit = bvData[year][tour].ins;
                let exprime = bvData[year][tour].exp;

                let candidats = bvData[year][tour].c.sort((a, b) => {
                    return a.r - b.r
                }).reverse();

                let pos2 = 0;
                if (candidats[1]) {
                    pos2 = 1
                }
                let perc = (candidats[0].r / exprime) - (candidats[pos2].r / exprime);
                if (candidats.length <= 1) {
                    perc = 1;
                }
                let infoElection = getInfoElection(perc);
                res.push({
                    year: year,
                    type: getNomElection[electionType],
                    inscrit: {
                        nb: inscrit,
                        perc: inscrit / winner.inscrit.nb,
                        total: winner.inscrit.nb
                    },
                    abstention: {
                        result: abstention,
                        perc: abstention / inscrit,
                        color: "#000",
                        trendPerc: computerTrendAbs(previousAbstention, abstention / inscrit)
                    },
                    winner: {
                        nomPrenom: candidats[0].nomPrenom,
                        result: candidats[0].r,
                        perc: candidats[0].r / exprime,
                        color: infoElection.color

                    },
                    nuance: getLabelFromNuance(candidats[0].nuance, year),
                    tour: tour
                })
                previousAbstention = abstention / inscrit
                if (Number(year) === Number(currentYear)) {
                    let findIndex = candidats.findIndex((candidat) => {
                        return candidat.nomPrenom === winner.winner.nomPrenom
                    });
                    if (candidats.length > 1) {
                        let nextIndex = findIndex === 0 ? 1 : 0;
                        lastYearStatus = getInfoElection((candidats[findIndex].r / exprime) - (candidats[nextIndex].r / exprime));
                    } else {
                        lastYearStatus = getInfoElection(1);
                    }

                }

            })


            if (lastYearStatus) {
                let bvInfo = result.bvInfoMongo[0].bureauxDeVote.find(bv => {
                    return bv.id_brut_miom === key
                })
                listOfBvs[lastYearStatus.type][key] = {
                    code: key,
                    name: bvInfo ? bvInfo.libelle_reu : key,
                    results: res.reverse(),
                    color: lastYearStatus.color
                }

            }
        })
        return listOfBvs
    }


    function generateGeomBVs(result) {
        let bvs = {}
        result.bvInfoMongo[0].bureauxDeVote.forEach((bv) => {
            const info2 = result.bvGeoMongo[0].bureauxDeVote.find(a => {
                let id = a.commune_code.padStart(5, '0') + "_" + a.code.padStart(4, '0');
                let id2 = a.commune_code.padStart(5, '0') + "_" + Number(a.code);
                if (result.convertionTableForBvs && result.convertionTableForBvs[id]) {
                    id = result.convertionTableForBvs[id];
                }
                if (result.convertionTableForBvs && result.convertionTableForBvs[id2]) {
                    id = result.convertionTableForBvs[id2];
                }

                return bv.id_brut_miom === id
            })
            bvs[bv.id_brut_miom] = {
                info: bv,
                info2: info2,
                code: bv.id_brut_miom,
                name: bv.libelle_reu,
                latitude: info2 ? info2.latitude : null,
                longitude: info2 ? info2.longitude : null
            }
        })
        return bvs;
    }

    function generateGeomIris(result) {
        return result.shapeIris;
    }

    function generateResultatsBvs(r) {
        let results = {}
        let previousYear = null;
        Object.keys(r).sort().reverse().forEach((year) => {

            r[year]["t1"].forEach(election => {

                if (!results[election.bvId]) {
                    results[election.bvId] = {
                        inscrits: {},
                        inscrits2: {},
                        abstentions: {},
                        blancs: {},
                        //      nuls: {},
                        tour: "t1"
                    }
                }
                if (!results[election.bvId].inscrits[year]) {
                    results[election.bvId].inscrits[year] = {nb: 0, perc: null, trendPerc: null, trend: null}
                    results[election.bvId].inscrits2[year] = {t1: {nb: 0, perc: null, trendPerc: null, trend: null}}
                    results[election.bvId].abstentions[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                    results[election.bvId].blancs[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                    //   results[election.bvId].nuls[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                }

                results[election.bvId].inscrits[year].nb += election.ins;
                results[election.bvId].inscrits2[year]["t1"].nb += election.ins;
                results[election.bvId].abstentions[year]["t1"].nb += election.abs;
                results[election.bvId].abstentions[year]["t1"].perc = results[election.bvId].abstentions[year]["t1"].nb / results[election.bvId].inscrits2[year]["t1"].nb;

                results[election.bvId].blancs[year]["t1"].nb += election.bla + election.nuls;
                results[election.bvId].blancs[year]["t1"].perc = results[election.bvId].blancs[year]["t1"].nb / results[election.bvId].inscrits2[year]["t1"].nb;

//                results[election.bvId].nuls[year]["t1"].nb += election.nuls;
//                results[election.bvId].nuls[year]["t1"].perc = results[election.bvId].nuls[year]["t1"].nb / results[election.bvId].inscrits[year].nb;
            })
            if (r[year]["t2"]) {
                r[year]["t2"].forEach(election => {

                    if (!results[election.bvId].abstentions[year]["t2"]) {
                        results[election.bvId].inscrits[year].nb = 0
                        results[election.bvId].inscrits2[year]["t2"] = {nb: 0, perc: null, trendPerc: null, trend: null}
                        results[election.bvId].abstentions[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        results[election.bvId].blancs[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        //results[election.bvId].nuls[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        results[election.bvId].tour = "t2"
                    }
                    results[election.bvId].inscrits[year].nb += election.ins;
                    results[election.bvId].inscrits2[year]["t2"].nb += election.ins;
                    results[election.bvId].inscrits2[year]["t2"].trendPerc = results[election.bvId].inscrits2[year]["t1"].nb > 0 ? (results[election.bvId].inscrits2[year]["t2"].nb / results[election.bvId].inscrits2[year]["t1"].nb) - 1 : 0;
                    if (results[election.bvId].inscrits2[year]["t2"].trendPerc >= 0) {
                        results[election.bvId].inscrits2[year]["t2"].trend = "up"
                    } else {
                        results[election.bvId].inscrits2[year]["t2"].trend = "down"
                    }

                    results[election.bvId].abstentions[year]["t2"].nb += election.abs;
                    results[election.bvId].abstentions[year]["t2"].perc = results[election.bvId].abstentions[year]["t2"].nb / results[election.bvId].inscrits2[year]["t2"].nb;
                    results[election.bvId].abstentions[year]["t2"].trendPerc = results[election.bvId].abstentions[year]["t1"].nb > 0 ? (results[election.bvId].abstentions[year]["t2"].nb / results[election.bvId].abstentions[year]["t1"].nb) - 1 : 0;
                    if (results[election.bvId].abstentions[year]["t2"].trendPerc >= 0) {
                        results[election.bvId].abstentions[year]["t2"].trend = "up"
                    } else {
                        results[election.bvId].abstentions[year]["t2"].trend = "down"
                    }

                    results[election.bvId].blancs[year]["t2"].nb += election.bla + election.nuls;
                    results[election.bvId].blancs[year]["t2"].perc = results[election.bvId].blancs[year]["t2"].nb / results[election.bvId].inscrits2[year]["t2"].nb;
                    results[election.bvId].blancs[year]["t2"].trendPerc = results[election.bvId].blancs[year]["t1"].nb > 0 ? (results[election.bvId].blancs[year]["t2"].nb / results[election.bvId].blancs[year]["t1"].nb) - 1 : 0;
                    if (results[election.bvId].blancs[year]["t2"].trendPerc >= 0) {
                        results[election.bvId].blancs[year]["t2"].trend = "up"
                    } else {
                        results[election.bvId].blancs[year]["t2"].trend = "down"
                    }

                    /*   results[election.bvId].nuls[year]["t2"].nb += election.nuls;
                       results[election.bvId].nuls[year]["t2"].perc = results[election.bvId].nuls[year]["t2"].nb / results[election.bvId].inscrits[year].nb;
                       results[election.bvId].nuls[year]["t2"].trendPerc = results[election.bvId].nuls[year]["t1"].nb > 0 ? (results[election.bvId].nuls[year]["t2"].nb / results[election.bvId].nuls[year]["t1"].nb) - 1 : 0;
                       if (results[election.bvId].nuls[year]["t2"].trendPerc >= 0) {
                           results[election.bvId].nuls[year]["t2"].trend = "up"
                       } else {
                           results[election.bvId].nuls[year]["t2"].trend = "down"
                       }*/
                })
            }
            previousYear = year;

        })
        return results;
    }

    function generateParCandidatsResultatsNuancesByBvs(r) {
        let results = {}

        Object.keys(r).sort().reverse().forEach((year) => {

            r[year]["t1"].forEach(bv => {
                if (!results[bv.bvId]) {
                    results[bv.bvId] = {
                        exprime: {},
                        candidats: {},
                        nuances: {},
                        inscrits: {}
                    }
                }
                if (!results[bv.bvId].exprime[year]) {
                    results[bv.bvId].exprime[year] = {t1: 0};
                    results[bv.bvId].candidats[year] = {t1: {}};
                    results[bv.bvId].nuances[year] = {t1: {}};
                    results[bv.bvId].inscrits[year] = 0;
                }

                results[bv.bvId].inscrits[year] += bv.ins;
                results[bv.bvId].exprime[year]["t1"] += bv.exp;
                bv.c.forEach(candidat => {
                    if (!results[bv.bvId].candidats[year]["t1"][candidat.nomPrenom]) {
                        results[bv.bvId].candidats[year]["t1"][candidat.nomPrenom] = {
                            nb: 0,
                            perc: 0,
                            nomPrenom: candidat.nomPrenom,
                            nuance: candidat.nuance
                        }
                    }
                    results[bv.bvId].candidats[year]["t1"][candidat.nomPrenom].nb += candidat.r;
                    results[bv.bvId].candidats[year]["t1"][candidat.nomPrenom].perc = results[bv.bvId].candidats[year]["t1"][candidat.nomPrenom].nb / results[bv.bvId].exprime[year]["t1"];

                    if (!results[bv.bvId].nuances[year]["t1"][candidat.nuance]) {
                        results[bv.bvId].nuances[year]["t1"][candidat.nuance] = {
                            nb: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    results[bv.bvId].nuances[year]["t1"][candidat.nuance].nb += candidat.r;
                    results[bv.bvId].nuances[year]["t1"][candidat.nuance].perc = results[bv.bvId].nuances[year]["t1"][candidat.nuance].nb / results[bv.bvId].exprime[year]["t1"];
                })
            })


            if (r[year]["t2"]) {
                r[year]["t2"].forEach(bv => {
                    if (!results[bv.bvId].exprime[year]["t2"]) {
                        results[bv.bvId].exprime[year]["t2"] = 0;
                        results[bv.bvId].candidats[year]["t2"] = {};
                        results[bv.bvId].nuances[year]["t2"] = {};
                    }

                    results[bv.bvId].exprime[year]["t2"] += bv.exp;
                    bv.c.forEach(candidat => {

                        if (!results[bv.bvId].candidats[year]["t2"][candidat.nomPrenom]) {
                            results[bv.bvId].candidats[year]["t2"][candidat.nomPrenom] = {
                                nb: 0,
                                perc: 0,
                                nomPrenom: candidat.nomPrenom,
                                nuance: candidat.nuance
                            }
                        }
                        results[bv.bvId].candidats[year]["t2"][candidat.nomPrenom].nb += candidat.r;
                        results[bv.bvId].candidats[year]["t2"][candidat.nomPrenom].perc = results[bv.bvId].candidats[year]["t2"][candidat.nomPrenom].nb / results[bv.bvId].exprime[year]["t2"];

                        if (!results[bv.bvId].nuances[year]["t2"][candidat.nuance]) {
                            results[bv.bvId].nuances[year]["t2"][candidat.nuance] = {
                                nb: 0,
                                perc: 0,
                                nuance: candidat.nuance
                            }
                        }
                        results[bv.bvId].nuances[year]["t2"][candidat.nuance].nb += candidat.r;
                        results[bv.bvId].nuances[year]["t2"][candidat.nuance].perc = results[bv.bvId].nuances[year]["t2"][candidat.nuance].nb / results[bv.bvId].exprime[year]["t2"];
                    })
                })
            }
        })

        return results;
    }

    function generateResultsParDonneesInseeByBvs(result, data) {
        let bvs = {}
        result.bvToIrisMongo.forEach((bv) => {
            let splitedBvId = bv.codeBv.split("_");
            let correctedId = splitedBvId[0].padStart(5, '0') + "_" + splitedBvId[1].padStart(4, '0');
            const correctedId2 = splitedBvId[0].padStart(5, '0') + "_" + Number(splitedBvId[1]);
if( result.convertionTableForBvs && result.convertionTableForBvs[correctedId2]) {
    correctedId= result.convertionTableForBvs[correctedId2];
}

            let listOfIris = [];
            let n = 0;
            Object.keys(bv.iris).forEach((item) => {
                n += bv.iris[item].length;
            })
            Object.keys(bv.iris).forEach((item) => {
                if (bv.iris[item].length / n > percentageRepresentation) {
                    listOfIris.push(item.replaceAll("'", ""));
                }
            })
            bvs[correctedId] = {
                listOfIris: listOfIris,
                popAge: generateInseePopResults(data.pop21, data.pop15, listOfIris),
                popCsp: generateInseeCspResults(data.csp21, data.csp15, listOfIris),
                popEtu: generateInseeEtuResults(data.edu21, data.edu15, listOfIris),
                popRevenues: generateInseeIncomeResults(data.actif21, data.actif15, listOfIris),
                lgtStatus: generateInseeLgtResults(data.lgt21, data.lgt15, listOfIris),
                lgtPeriode: generateInseeLgtPResults(data.lgtpe21, data.lgtpe15, listOfIris)
            };
            if (listOfIris.length === 1 && listOfIris[0] === '132090702') {

            }
        })
        return bvs;

    }

    function generateResultatsByPersona(r, mappingBvCategory) {
        let results = {}
        let previousYear = null;
        Object.keys(r).sort().reverse().forEach((year) => {
            let category = "winner";
            r[year]["t1"].forEach(election => {
                Object.keys(mappingBvCategory).forEach((keyMapping) => {
                    if (mappingBvCategory[keyMapping].includes(election.bvId)) {
                        category = keyMapping;
                    }
                })
                if (!results[category]) {
                    results[category] = {
                        inscrits: {},
                        inscrits2: {},
                        abstentions: {},
                        blancs: {},
                        //    nuls: {},
                        tour: "t1"
                    }
                }
                if (!results[category].inscrits[year]) {
                    results[category].inscrits[year] = {nb: 0, perc: null, trendPerc: null, trend: null}
                    results[category].inscrits2[year] = {t1: {nb: 0, perc: null, trendPerc: null, trend: null}}
                    results[category].abstentions[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                    results[category].blancs[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                    // results[category].nuls[year] = {t1: {nb: 0, perc: 0, trendPerc: null, trend: null}}
                }

                results[category].inscrits[year].nb += election.ins;
                results[category].inscrits2[year]["t1"].nb += election.ins;
                results[category].abstentions[year]["t1"].nb += election.abs;
                results[category].abstentions[year]["t1"].perc = results[category].abstentions[year]["t1"].nb / results[category].inscrits2[year]["t1"].nb;

                results[category].blancs[year]["t1"].nb += election.bla + election.nuls;
                results[category].blancs[year]["t1"].perc = results[category].blancs[year]["t1"].nb / results[category].inscrits2[year]["t1"].nb;

                //   results[category].nuls[year]["t1"].nb += election.nuls;
                //   results[category].nuls[year]["t1"].perc = results[category].nuls[year]["t1"].nb / results[category].inscrits[year].nb;
            })
            if (r[year]["t2"]) {


                r[year]["t2"].forEach(election => {
                    Object.keys(mappingBvCategory).forEach((keyMapping) => {
                        if (mappingBvCategory[keyMapping].includes(election.bvId)) {
                            category = keyMapping;
                        }
                    })

                    if (!results[category].abstentions[year]["t2"]) {
                        results[category].abstentions[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        results[category].inscrits2[year]["t2"] = {nb: 0, perc: null, trendPerc: null, trend: null}
                        results[category].blancs[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        //results[category].nuls[year]["t2"] = {nb: 0, perc: 0, trendPerc: null, trend: null}
                        results[category].tour = "t2"
                    }
                    results[category].inscrits2[year]["t2"].nb += election.ins;
                    results[category].inscrits2[year]["t2"].trendPerc = results[category].inscrits2[year]["t1"].nb > 0 ? (results[category].inscrits2[year]["t2"].nb / results[category].inscrits2[year]["t1"].nb) - 1 : 0;
                    if (results[category].inscrits2[year]["t2"].trendPerc >= 0) {
                        results[category].inscrits2[year]["t2"].trend = "up"
                    } else {
                        results[category].inscrits2[year]["t2"].trend = "down"
                    }


                    results[category].abstentions[year]["t2"].nb += election.abs;
                    results[category].abstentions[year]["t2"].perc = results[category].abstentions[year]["t2"].nb / results[category].inscrits2[year]["t2"].nb;
                    results[category].abstentions[year]["t2"].trendPerc = results[category].abstentions[year]["t1"].nb > 0 ? (results[category].abstentions[year]["t2"].nb / results[category].abstentions[year]["t1"].nb) - 1 : 0;
                    if (results[category].abstentions[year]["t2"].trendPerc >= 0) {
                        results[category].abstentions[year]["t2"].trend = "up"
                    } else {
                        results[category].abstentions[year]["t2"].trend = "down"
                    }

                    results[category].blancs[year]["t2"].nb += election.bla + election.nuls;
                    results[category].blancs[year]["t2"].perc = results[category].blancs[year]["t2"].nb / results[category].inscrits2[year]["t2"].nb;
                    results[category].blancs[year]["t2"].trendPerc = results[category].blancs[year]["t1"].nb > 0 ? (results[category].blancs[year]["t2"].nb / results[category].blancs[year]["t1"].nb) - 1 : 0;
                    if (results[category].blancs[year]["t2"].trendPerc >= 0) {
                        results[category].blancs[year]["t2"].trend = "up"
                    } else {
                        results[category].blancs[year]["t2"].trend = "down"
                    }

                    /*results[category].nuls[year]["t2"].nb += election.nuls;
                    results[category].nuls[year]["t2"].perc = results[category].nuls[year]["t2"].nb / results[category].inscrits[year].nb;
                    results[category].nuls[year]["t2"].trendPerc = results[category].nuls[year]["t1"].nb > 0 ? (results[category].nuls[year]["t2"].nb / results[category].nuls[year]["t1"].nb) - 1 : 0;
                    if (results[category].nuls[year]["t2"].trendPerc >= 0) {
                        results[category].nuls[year]["t2"].trend = "up"
                    } else {
                        results[category].nuls[year]["t2"].trend = "down"
                    }*/
                })
            }
            previousYear = year;

        })
        return results;
    }

    function generateBvCategory(valuesOfResultsByBvs) {
        let mappingBvCategory = {
            winner: [],
            winnerJuste: [],
            winnerPeu: [],
            winnerLargement: []
        }
        Object.keys(valuesOfResultsByBvs).forEach(key => {
            mappingBvCategory[key] = Object.keys(valuesOfResultsByBvs[key]);
        })
        return mappingBvCategory;
    }

    function generateParCandidatsResultatsNuancesByPersona(r, mappingBvCategory) {
        let results = {}

        Object.keys(r).sort().reverse().forEach((year) => {
            let category = "winner";
            r[year]["t1"].forEach(bv => {
                Object.keys(mappingBvCategory).forEach((keyMapping) => {
                    if (mappingBvCategory[keyMapping].includes(bv.bvId)) {
                        category = keyMapping;
                    }
                })

                if (!results[category]) {
                    results[category] = {
                        exprime: {},
                        candidats: {},
                        nuances: {},
                        inscrits: {}
                    }
                }
                if (!results[category].exprime[year]) {
                    results[category].exprime[year] = {t1: 0};
                    results[category].candidats[year] = {t1: {}};
                    results[category].nuances[year] = {t1: {}};
                    results[category].inscrits[year] = 0;
                }

                results[category].inscrits[year] += bv.ins;
                results[category].exprime[year]["t1"] += bv.exp;
                bv.c.forEach(candidat => {
                    if (!results[category].candidats[year]["t1"][candidat.nomPrenom]) {
                        results[category].candidats[year]["t1"][candidat.nomPrenom] = {
                            nb: 0,
                            perc: 0,
                            nomPrenom: candidat.nomPrenom,
                            nuance: candidat.nuance
                        }
                    }
                    results[category].candidats[year]["t1"][candidat.nomPrenom].nb += candidat.r;
                    results[category].candidats[year]["t1"][candidat.nomPrenom].perc = results[category].candidats[year]["t1"][candidat.nomPrenom].nb / results[category].exprime[year]["t1"];

                    if (!results[category].nuances[year]["t1"][candidat.nuance]) {
                        results[category].nuances[year]["t1"][candidat.nuance] = {
                            nb: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    results[category].nuances[year]["t1"][candidat.nuance].nb += candidat.r;
                    results[category].nuances[year]["t1"][candidat.nuance].perc = results[category].nuances[year]["t1"][candidat.nuance].nb / results[category].exprime[year]["t1"];
                })
            })

            if (r[year]["t2"]) {

                let category = "winner";
                r[year]["t2"].forEach(bv => {
                    Object.keys(mappingBvCategory).forEach((keyMapping) => {
                        if (mappingBvCategory[keyMapping].includes(bv.bvId)) {
                            category = keyMapping;
                        }
                    })
                    if (!results[category].exprime[year]["t2"]) {
                        results[category].exprime[year]["t2"] = 0;
                        results[category].candidats[year]["t2"] = {};
                        results[category].nuances[year]["t2"] = {};
                    }

                    results[category].exprime[year]["t2"] += bv.exp;
                    bv.c.forEach(candidat => {

                        if (!results[category].candidats[year]["t2"][candidat.nomPrenom]) {
                            results[category].candidats[year]["t2"][candidat.nomPrenom] = {
                                nb: 0,
                                perc: 0,
                                nomPrenom: candidat.nomPrenom,
                                nuance: candidat.nuance
                            }
                        }
                        results[category].candidats[year]["t2"][candidat.nomPrenom].nb += candidat.r;
                        results[category].candidats[year]["t2"][candidat.nomPrenom].perc = results[category].candidats[year]["t2"][candidat.nomPrenom].nb / results[category].exprime[year]["t2"];

                        if (!results[category].nuances[year]["t2"][candidat.nuance]) {
                            results[category].nuances[year]["t2"][candidat.nuance] = {
                                nb: 0,
                                perc: 0,
                                nuance: candidat.nuance
                            }
                        }
                        results[category].nuances[year]["t2"][candidat.nuance].nb += candidat.r;
                        results[category].nuances[year]["t2"][candidat.nuance].perc = results[category].nuances[year]["t2"][candidat.nuance].nb / results[category].exprime[year]["t2"];
                    })
                })
            }
        })

        return results;
    }

    function generateResultsParDonneesInseeByPersona(result, data, mappingBvCategory) {
        let bvs = {
            winner: [],
            winnerJuste: [],
            winnerPeu: [],
            winnerLargement: []
        }
        Object.keys(mappingBvCategory).forEach(type => {

            let listOfIris = {};
            mappingBvCategory[type].forEach((bvId) => {
                let bv = result.bvToIrisMongo.find(bv => {
                    let splitedBvId = bv.codeBv.split("_");
                    let correctedId = splitedBvId[0].padStart(5, '0') + "_" + splitedBvId[1].padStart(4, '0');

                    if (bvId.includes("13055")) {
                        correctedId = "13055_" + splitedBvId[1].padStart(4, '0');
                    } else if (bvId.includes("69123")) {
                        correctedId = "69123_" + splitedBvId[1].padStart(4, '0');
                    } else if (bvId.includes("75056")) {
                        correctedId = result.convertionTableForBvs[bv.codeBv]
                    }
                    return bvId === correctedId
                })
                let n = 0;

                if (!bv) {
                    if (mappingChelou[bvId].iris) {

                        bv = {
                            iris: mappingChelou[bvId].iris
                        };
                    }

                }
                if (bv) {
                    Object.keys(bv.iris).forEach((item) => {
                        n += bv.iris[item].length;
                    })
                    Object.keys(bv.iris).forEach((item) => {
                        if (bv.iris[item].length / n > percentageRepresentation) {
                            listOfIris[(item.replaceAll("'", ""))] = 1;
                        }
                    })
                }
            })
            bvs[type] = {
                listOfBvs: mappingBvCategory[type],
                listOfIris: Object.keys(listOfIris),
                popAge: generateInseePopResults(data.pop21, data.pop15, Object.keys(listOfIris)),
                popCsp: generateInseeCspResults(data.csp21, data.csp15, Object.keys(listOfIris)),
                popEtu: generateInseeEtuResults(data.edu21, data.edu15, Object.keys(listOfIris)),
                popRevenues: generateInseeIncomeResults(data.actif21, data.actif15, Object.keys(listOfIris)),
                lgtStatus: generateInseeLgtResults(data.lgt21, data.lgt15, Object.keys(listOfIris)),
                lgtPeriode: generateInseeLgtPResults(data.lgtpe21, data.lgtpe15, Object.keys(listOfIris))
            };

        })
        let finalBvs = {}
        Object.keys(bvs).forEach(type => {
            if (bvs[type].listOfBvs.length > 0 || bvs[type].listOfIris.length > 0) {
                finalBvs[type] = bvs[type];
            }
        })
        return finalBvs;
    }

    function generateResultByiris(result, mappingBvCategory) {
        let results = {}

        result.irisToBanMongo.forEach((iris) => {
            let codeIris = iris.iris.replaceAll("'", "");
            let bvs = {}
            Object.keys(iris.banMap).forEach(bvCode => {
                let colorType = null;
                let splittedBvCode = bvCode.split("_");
                let correctedId = splittedBvCode[0].padStart(5, '0') + "_" + splittedBvCode[1].padStart(4, '0');
                if (result.convertionTableForBvs && result.convertionTableForBvs[correctedId]) {
                    correctedId = result.convertionTableForBvs[correctedId];
                }
                if (result.convertionTableForBvs && result.convertionTableForBvs[bvCode]) {
                    correctedId = result.convertionTableForBvs[bvCode];
                }

                Object.keys(mappingBvCategory).forEach(type => {
                    if (mappingBvCategory[type].includes(correctedId)) {
                        colorType = type;
                    }
                })
                bvs[correctedId] = {
                    code: correctedId,
                    color: colorType,
                    bans: iris.banMap[bvCode]
                }
            })
            results[codeIris] = {
                iris: codeIris,
                codeCommune: iris.codeCommune,
                bvs: bvs
            }

        })
        return results;
    }


    function generateSyntheseAllElection(result, mappingBvCategory) {
        let invertMappingOfBvs = {};
        Object.keys(mappingBvCategory).forEach(type => {
            mappingBvCategory[type].forEach(id => {
                invertMappingOfBvs[id] = type;
            })
        })


        let listOfBvs = result.bvResultsComboMongo[0].bvResultsMap;
        let res = {
            global: {},
            byAggregate: {},
            byBvs: {}
        }
        Object.keys(listOfBvs).forEach((bvId) => {
            let aggregateType = invertMappingOfBvs[bvId];
            let electionOfBv = listOfBvs[bvId].elections;
            if (!aggregateType) {
                aggregateType = "notMapped"
            }
            if (!res.byBvs[bvId]) {
                res.byBvs[bvId] = {}
            }
            Object.keys(electionOfBv).forEach((election) => {
                let type = electionOfBv[election].type;
                let tour = electionOfBv[election].tour;
                let annee = electionOfBv[election].annee;
                //TODO if(type !== electionType && !res.byBvs[bvId][type]){
                if (!res.byBvs[bvId][annee]) {
                    res.byBvs[bvId][annee] = {}
                }
                if (!res.byBvs[bvId][annee][type]) {
                    res.byBvs[bvId][annee][type] = {}
                }
                res.byBvs[bvId][annee][type][tour] = electionOfBv[election];
                res.byBvs[bvId][annee][type][tour].bla = res.byBvs[bvId][annee][type][tour].bla + res.byBvs[bvId][annee][type][tour].nuls
                res.byBvs[bvId][annee][type][tour].candidats = electionOfBv[election].c;

                if (!res.byBvs[bvId][annee][type][tour].nuances) {
                    res.byBvs[bvId][annee][type][tour].nuances = {}
                }
                electionOfBv[election].c.forEach(candidat => {
                    if (!res.byBvs[bvId][annee][type][tour].nuances[candidat.nuance]) {
                        res.byBvs[bvId][annee][type][tour].nuances[candidat.nuance] = {
                            r: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    res.byBvs[bvId][annee][type][tour].nuances[candidat.nuance].r += candidat.r;
                    res.byBvs[bvId][annee][type][tour].nuances[candidat.nuance].perc = res.byBvs[bvId][annee][type][tour].nuances[candidat.nuance].r / res.byBvs[bvId][annee][type][tour].exp;
                })

                if (!res.byAggregate[aggregateType]) {
                    res.byAggregate[aggregateType] = {}
                }
                if (!res.byAggregate[aggregateType][annee]) {
                    res.byAggregate[aggregateType][annee] = {}
                }
                if (!res.byAggregate[aggregateType][annee][type]) {
                    res.byAggregate[aggregateType][annee][type] = {}
                }

                if (!res.byAggregate[aggregateType][annee][type][tour]) {
                    res.byAggregate[aggregateType][annee][type][tour] = {
                        ins: 0,
                        exp: 0,
                        abs: 0,
                        bla: 0,
                        candidats: {},
                        nuances: {}
                    }
                }
                res.byAggregate[aggregateType][annee][type][tour].ins += electionOfBv[election].ins;
                res.byAggregate[aggregateType][annee][type][tour].exp += electionOfBv[election].exp;
                res.byAggregate[aggregateType][annee][type][tour].abs += electionOfBv[election].abs;
                res.byAggregate[aggregateType][annee][type][tour].bla += electionOfBv[election].bla + electionOfBv[election].nuls;

                electionOfBv[election].c.forEach(candidat => {
                    if (!res.byAggregate[aggregateType][annee][type][tour].candidats[candidat.nomPrenom]) {
                        res.byAggregate[aggregateType][annee][type][tour].candidats[candidat.nomPrenom] = {
                            r: 0,
                            perc: 0,
                            nomPrenom: candidat.nomPrenom,
                            nuance: candidat.nuance
                        }
                    }
                    res.byAggregate[aggregateType][annee][type][tour].candidats[candidat.nomPrenom].r += candidat.r;
                    res.byAggregate[aggregateType][annee][type][tour].candidats[candidat.nomPrenom].perc = res.byAggregate[aggregateType][annee][type][tour].candidats[candidat.nomPrenom].r / res.byAggregate[aggregateType][annee][type][tour].exp;

                    if (!res.byAggregate[aggregateType][annee][type][tour].nuances[candidat.nuance]) {
                        res.byAggregate[aggregateType][annee][type][tour].nuances[candidat.nuance] = {
                            r: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    res.byAggregate[aggregateType][annee][type][tour].nuances[candidat.nuance].r += candidat.r;
                    res.byAggregate[aggregateType][annee][type][tour].nuances[candidat.nuance].perc = res.byAggregate[aggregateType][annee][type][tour].nuances[candidat.nuance].r / res.byAggregate[aggregateType][annee][type][tour].exp;
                })

                if (!res.global[annee]) {
                    res.global[annee] = {}
                }
                if (!res.global[annee][type]) {
                    res.global[annee][type] = {}
                }

                if (!res.global[annee][type][tour]) {
                    res.global[annee][type][tour] = {
                        ins: 0,
                        exp: 0,
                        abs: 0,
                        bla: 0,
                        candidats: {},
                        nuances: {}
                    }
                }

                res.global[annee][type][tour].ins += electionOfBv[election].ins;
                res.global[annee][type][tour].exp += electionOfBv[election].exp;
                res.global[annee][type][tour].abs += electionOfBv[election].abs;
                res.global[annee][type][tour].bla += electionOfBv[election].bla + electionOfBv[election].nuls;
                electionOfBv[election].c.forEach(candidat => {
                    if (!res.global[annee][type][tour].candidats[candidat.nomPrenom]) {
                        res.global[annee][type][tour].candidats[candidat.nomPrenom] = {
                            r: 0,
                            perc: 0,
                            nomPrenom: candidat.nomPrenom,
                            nuance: candidat.nuance
                        }
                    }
                    res.global[annee][type][tour].candidats[candidat.nomPrenom].r += candidat.r;
                    res.global[annee][type][tour].candidats[candidat.nomPrenom].perc = res.global[annee][type][tour].candidats[candidat.nomPrenom].r / res.global[annee][type][tour].exp;

                    if (!res.global[annee][type][tour].nuances[candidat.nuance]) {
                        res.global[annee][type][tour].nuances[candidat.nuance] = {
                            r: 0,
                            perc: 0,
                            nuance: candidat.nuance
                        }
                    }
                    res.global[annee][type][tour].nuances[candidat.nuance].r += candidat.r;
                    res.global[annee][type][tour].nuances[candidat.nuance].perc = res.global[annee][type][tour].nuances[candidat.nuance].r / res.global[annee][type][tour].exp;
                })
            })
        });
        return res;
    }

    React.useEffect(() => {
        ApiVoteCtrl.getAlldata(codeInsee, (result) => {


            let r = aggregateResultsByYear(JSON.parse(JSON.stringify(result)));
            let listOfWinner = generateSyntheseCommune(JSON.parse(JSON.stringify(r)));
            let winner = listOfWinner.sort((a, b) => {
                return a.year - b.year
            }).reverse()[0];

            setResultsSyntheseCommune(listOfWinner);

            let tmp = generateBVs(result, winner, datesByElection[electionType].max);



        })
    }, [codeInsee, electionType, loading])

    const [resultsSynthese, setResultsSyntheseCommune] = React.useState(null);


    React.useEffect(() => {
        if (resultsSynthese) {
            setLoading(false);
        }
    }, [resultsSynthese])

    const options = {
        filename: "advanced-example.pdf",
        // default is `save`
        method: "save",
        // default is Resolution.MEDIUM = 3, which should be enough, higher values
        // increases the image quality but also the size of the PDF, so be careful
        // using values higher than 10 when having multiple pages generated, it
        // might cause the page to crash or hang.
        resolution: Resolution.HIGH,
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL,
            // default is 'A4'
            format: "letter",
            // default is 'portrait'
            orientation: "landscape",
        },
        canvas: {
            // default is 'image/jpeg' for better size performance
            mimeType: "image/png",
            qualityRatio: 1,
        },
        // customize any value passed to the jsPDF instance and html2canvas
        // function
        overrides: {
            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
            pdf: {
                compress: true,
            },
            // see https://html2canvas.hertzen.com/configuration for more options
            canvas: {
                useCORS: true,
            },
        },
    };
    const {toPDF, targetRef} = usePDF({filename: 'page.pdf'}, options);
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const pdfExportComponent = React.useRef(null);
    const exportPDFWithMethod = () => {
        pdfExportComponent.current.save();
    };


    if (loading) {
        return (
            <Box sx={{
                m: 5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            overflow: "hidden",
            width: "100%",
            justifyContent: "center",
        }}>
            <SyntheseMain results={resultsSynthese} codeInsee={codeInsee} electionType={electionType}/>

        </Box>
    );
}
